import React from 'react';
import Test from './Test';

const Win = () => {
    return (
        <div>
            <Test/>
            <h1>You Won</h1>
        </div>
    );
};

export default Win;